import { FC, memo } from 'react';
import Head from 'next/head';
import { useRouter } from 'next/router';
import Layout from 'features/layout/templates/Layout';
import { useAuthGuard } from 'features/auth/hooks/useAuthGuard';
import { useProfile } from 'hooks/useProfile';

import { Spinner } from 'src/components/Spinner';

import { Heading } from './components/Heading';
import { ProfileForm } from './components/ProfileForm';

const noOp = () => {
  /* to rewrite default behavior */
};

const EditProfile: FC = () => {
  const router = useRouter();
  useAuthGuard({ from: router.asPath });

  const { data, isFetched } = useProfile({
    onSuccess: noOp,
  });

  return (
    <>
      <Head>
        <meta key="robots" name="robots" content="noindex" />
        <meta key="googlebot" name="googlebot" content="noindex" />
      </Head>
      {!isFetched && <Spinner fullScreen />}
      <Layout>
        <Heading
          profilePicSrc={data?.profileImg}
          firstName={data?.firstName}
          lastName={data?.lastName}
        />
        {data && <ProfileForm profile={data} />}
      </Layout>
    </>
  );
};

export default memo(EditProfile);
